var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PromoBanners'),_c('FlashDeals'),(!_vm.noBestSellersProduct)?_c('BestSellers'):_vm._e(),_c('HotDeals'),_c('Article')],1)}
var staticRenderFns = []

export { render, staticRenderFns }